//export const SERVICE_URL = `http://127.0.0.1:3000/`;
export const SERVICE_URL = `https://ks5jby85id.execute-api.us-east-2.amazonaws.com/Prod/`
export const STATUS_CODE = {
    SUCCESS: "SUCCESS"
  };




  